"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _orderFormTypes = require("../../constants/sendOrder/orderFormTypes");
var _orderHelper = require("../../helpers/orderHelper");
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _selectors = require("../../redux/margin/selectors");
var _buySellSelectors = require("../../redux/selectors/buySellSelectors");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _orderEntrySelector = require("../../redux/selectors/orderEntrySelector");
var _ConfirmOrderModalComponent = _interopRequireDefault(require("./ConfirmOrderModalComponent"));
var _marginActions = require("../../../lib/redux/margin/actions/marginActions");
var _actions = require("../../redux/margin/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, props) {
  var ORDER_ENTRY_FORM_ID = props.formName || 'orderEntry';
  var form = state.form,
    product = state.apexCore.product;
  var formObj = form[ORDER_ENTRY_FORM_ID] || {
    values: {
      fee: {}
    }
  };
  var productId = formObj.values.fee.ProductId || formObj.values.fee.FeeProductId;
  var feeSymbol = productId ? product.products.find(function (item) {
    return item.ProductId === productId;
  }).Product : '';
  var marketPrice = (0, _buySellSelectors.marketPriceOfSelectedInstrumentSelector)(state, {
    side: formObj.values.side,
    formatToLocale: false
  });
  var price = (0, _orderHelper.getOrderPrice)(formObj, marketPrice);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var orderTotal = (0, _orderEntrySelector.orderTotalSelector)(state, props);
  var leverage = (0, _selectors.currentLeverageSelector)(state);
  return {
    formObj: formObj,
    feeSymbol: feeSymbol,
    price: price,
    selectedInstrument: selectedInstrument,
    isMarginActive: (0, _selectors.isMarginActiveSelector)(state),
    selectedMarginInstrument: (0, _selectors.selectMarginInstrumentConfig)(state),
    orderTotal: orderTotal,
    level1: state.apexCore.level1[selectedInstrument.InstrumentId],
    leverage: leverage
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var ORDER_ENTRY_FORM_ID = ownProps.formName || 'orderEntry';
  var orderFormType = ORDER_ENTRY_FORM_ID === 'advancedOrderEntry' ? _orderFormTypes.orderFormTypes.advanced : _orderFormTypes.orderFormTypes["default"];
  return {
    confirmReport: function confirmReport(formValues) {
      dispatch((0, _orderEntryActions.placeOrder)(orderFormType, formValues)).then(function () {
        dispatch((0, _reduxForm.reset)(ORDER_ENTRY_FORM_ID));
        dispatch((0, _reduxForm.change)(ORDER_ENTRY_FORM_ID, 'side', formValues.side));
        dispatch((0, _reduxForm.change)(ORDER_ENTRY_FORM_ID, 'orderType', formValues.orderType));
        dispatch((0, _reduxForm.change)(ORDER_ENTRY_FORM_ID, 'anchoredField', formValues.anchoredField));
        dispatch((0, _marginActions.refreshMarginAccountInfo)());
        dispatch((0, _actions.refreshMarginAccountEquity)());
      });
    }
  };
};
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_ORDER_REPORT
})((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmOrderModalComponent["default"]));